import { memo } from 'react';

const RenderHeaderLabelContent = memo(({ selectedOptionsCount }: { selectedOptionsCount: number }) => {
  return <div>CAST {selectedOptionsCount ? <span>• {selectedOptionsCount} PRESENTERS</span> : null}</div>;
});

RenderHeaderLabelContent.displayName = 'RenderHeaderLabelContent';

export default RenderHeaderLabelContent;
